import { useTranslation } from 'react-i18next'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import { REQUEST_STATUS } from '../../../constants/request'
import { EntityExtraTags } from '../../EntityExtraTags'
import { BirdviewRowAddress } from '../BirdviewRowAddress'
import { BirdviewRowDeadline } from '../BirdviewRowDeadline'
import { BIRDVIEW_REQUEST_ACTION_KEY } from '../DashboardBirdview.constants'
import { getBirdviewRequestAssignee } from '../DashboardBirdview.utils.rows'
import { DashboardListRow } from '../DashboardListRow'

import {
  checkIsBirdviewAssignAction,
  getBirdviewRequestAction,
  getBirdviewRequestDeadlineMetaProps,
} from './BirdviewServiceRequestRow.utils'

import ServiceRequestIcon from '../../../icons/service-request.svg'

function BirdviewServiceRequestRow({
  Meta = BirdviewRowDeadline,
  actionKey,
  extra,
  getMetaProps = getBirdviewRequestDeadlineMetaProps,
  item,
  requestActions = EMPTY_OBJECT,
  onOpen,
}) {
  const { t } = useTranslation()

  const {
    assigneeById = EMPTY_OBJECT,
    pendingIds = EMPTY_LIST,
    onAssign,
  } = requestActions

  const requestStatus = REQUEST_STATUS[item.status]
  const assignee = getBirdviewRequestAssignee(item, assigneeById)
  const action = getBirdviewRequestAction({
    assignee,
    isInteractive: !!onAssign,
    item,
  })

  function handleOpen() {
    onOpen(item)
  }

  function handleAction() {
    if (checkIsBirdviewAssignAction(action)) {
      onAssign(item)
    } else {
      onOpen(item)
    }
  }

  return (
    <DashboardListRow
      Icon={ServiceRequestIcon}
      Meta={Meta}
      Subtitle={BirdviewRowAddress}
      Tags={extra ? EntityExtraTags : null}
      actionKey={actionKey ?? BIRDVIEW_REQUEST_ACTION_KEY[action]}
      isActionPending={pendingIds.includes(item.id)}
      isUnread={item.unread}
      metaProps={getMetaProps({ item, t })}
      number={item.number}
      statusProps={{
        backgroundColor: requestStatus.backgroundColor,
        text: t(requestStatus.text),
        textColor: requestStatus.textColor,
      }}
      subtitleProps={{
        address: item.address,
        assignee,
        flat: item.flat,
      }}
      tagsProps={{ extra, id: item.id, interactable: true }}
      title={item.title}
      onAction={handleAction}
      onOpen={handleOpen}
    />
  )
}

export default BirdviewServiceRequestRow
